import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

interface ApplyFilterButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

const ApplyFilterButton: FC<ApplyFilterButtonProps> = ({
  disabled,
  onClick,
}) => {
  const { t } = useTranslation('followUp');
  return (
    <Button
      disabled={disabled}
      fullWidth
      onClick={onClick}
      variant="cta"
      color="secondary"
      sx={{ position: 'sticky', bottom: 0 }}
    >
      {t('applyFilter')}
    </Button>
  );
};

export default ApplyFilterButton;
